import React from 'react'
import ContactNotesGrid from '../../components/grids/ContactNotesGrid';
import ContactNoteDialog from '../../dialogs/notes/ContactNoteDialog';
import { ContactDetails } from '@agtech/data/contacts/ContactData';

const ContactPopUpNotesTab = (props: { contactDetails: ContactDetails }) => {
    const contact = props.contactDetails.contact;

    return (
        <div className='stretched row-based scrollable px-5 py-4 flex'>
            <ContactNotesGrid
                contactId={contact.id}
                gridProps={props => ({
                    ...props,
                    header: undefined,
                    noRecordsConfig: {
                        message: 'No notes were found for this contact',
                        action: {
                            prompt: 'To create one, click the button below',
                            button: () => (
                                <ContactNoteDialog.Button
                                    contactId={contact.id}
                                    classes='button-highlight'
                                />
                            )
                        }
                    },
                    actions: {
                        ...props.actions,
                        gridActions: {
                            width: '',
                            rendering: () => (
                                <ContactNoteDialog.Button
                                    contactId={contact.id}
                                    classes='button-link'
                                />
                            )
                        }
                    }
                })}
            />
        </div>
    )
}

export default ContactPopUpNotesTab